import { MenuItem, Select, TextField } from "@mui/material";
import { CountryCode } from "libphonenumber-js/types";
import { forwardRef, useEffect } from "react";
import PhoneInput, {
  getCountries,
  isValidPhoneNumber,
  parsePhoneNumber,
} from "react-phone-number-input/input";
import en from "react-phone-number-input/locale/en.json";

interface CountrySelectProps {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  country: any;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setCountry: any;
}

interface PhoneEntryProps {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  country: any;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setCountry: any;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  phoneNumber: any;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setPhoneNumber: any;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  phoneInputComponent: any;
  setDisableButton?: React.Dispatch<React.SetStateAction<boolean>>;
}

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/display-name
export const ContactPhoneInput = forwardRef((props, ref) => {
  return (
    <TextField
      {...props}
      label="Contact Phone Number"
      key="contactPhoneInputField"
      variant="standard"
      inputRef={ref}
      required
    />
  );
});

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/display-name
export const ActivityPhoneInput = forwardRef((props, ref) => {
  return (
    <TextField
      {...props}
      label="Activity Phone Number"
      key="activityPhoneInputField"
      variant="standard"
      inputRef={ref}
      required
    />
  );
});

const CountrySelect: React.FC<CountrySelectProps> = ({ country, setCountry }) => {
  return (
    <Select value={country} onChange={(event) => setCountry(event.target.value as CountryCode)}>
      {getCountries().map((countryCode: CountryCode) => (
        <MenuItem key={countryCode} value={countryCode}>
          {en[countryCode]}
        </MenuItem>
      ))}
    </Select>
  );
};

export const PhoneEntry: React.FC<PhoneEntryProps> = ({
  country,
  setCountry,
  phoneNumber,
  setPhoneNumber,
  phoneInputComponent,
  setDisableButton,
}) => {
  const countryCode = parsePhoneNumber(phoneNumber ?? "")?.country;
  const errorText = phoneNumber
    ? isValidPhoneNumber(phoneNumber, countryCode)
      ? null
      : "Invalid phone number for country"
    : null;

  useEffect(() => {
    errorText ? setDisableButton?.(true) : setDisableButton?.(false);
  }, [errorText]);

  return (
    <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
      <CountrySelect country={country} setCountry={setCountry} />
      <PhoneInput
        defaultCountry="US"
        country={country}
        rules={{
          required: true,
        }}
        value={phoneNumber}
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        onChange={setPhoneNumber as any}
        inputComponent={phoneInputComponent}
        error={errorText}
        helperText={errorText}
      />
    </div>
  );
};
